module.exports = __webpack_public_path__ + "static/media/logo.75cd225d.svg";